import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-ai-agent }}",{ moduleName: "embercom/templates/apps/app/automation/fin-ai-agent/analyze/incidents.hbs" })